export const END_POINT = {
  images: '/images',
  subImages: '/sub-images',
  labelSets: '/label-sets',
  labelSetsDetail: (id: string) => `/label-sets/${id}`,
  labelSetsDraft: '/label-sets/draft',
  labelSetsUpdateDraft: (id: string) => `/label-sets/${id}/draft`,
  organizations: '/organizations',
  organizationsOfMe: '/me/organizations',
  organizationDetail: (id: string) => `/organizations/${id}`,
  organizationShop: (id: string) => `/organizations/${id}/shops`,
  organizationAccounts: (id: string) => `/organizations/${id}/accounts`,
  organizationWeddingShop: (id: string) =>
    `/organizations/${id}/shops/weddings`,
  organizationBillingInformation: (id: string) =>
    `/organizations/${id}/invoice-managements`,
  drinkMaterial: (id: string) =>
    `/organizations/${id}/drink-and-material-orders`,
  drinkMaterialItems: '/drink-and-materials',
  drinkMaterialDetail: (id: string) => `/drink-and-material-orders/${id}`,
  drinkMaterialRegistration: (id: string) =>
    `/shops/${id}/drink-and-material-orders`,
  printerAndFixtures: (id: string) =>
    `/organizations/${id}/printer-and-fixtures`,
  printerAndFixturesRequest: (id: string) =>
    `/shops/${id}/printer-and-fixtures`,
  printerAndFixturesDetail: (id: string) => `/printer-and-fixtures/${id}`,
  requestChangePassword: '/request-change-password',
  accounts: '/accounts',
  accountsDetail: (id: string) => `/accounts/${id}`,
  myAccount: '/me/account',
  accountsForgotPassword: '/accounts/forgot-password',
  accountsPasswordRegistration: '/accounts/password-registration',
  accountsPasswordRegistrationVerify: '/accounts/password-registration-verify',
  accountsResetPassword: '/accounts/reset-password',
  accountsResetPasswordVerify: '/accounts/reset-password-verify',
  accountsResendInvitationMail: (id: string) =>
    `/accounts/${id}/resend-confirmation-code`,
  saleAreas: '/sale-areas',
  shops: '/shops',
  shopDetail: (id: string) => `/shops/${id}`,
  shopWeddingDetail: (id: string) => `/shops/${id}/weddings`,
  shopRejectRequests: (id: string) => `/shops/${id}/temporaries/returned`,
  shopApproveRequests: (id: string) => `/shops/${id}/temporaries/approve`,
  shopWithdrawRequests: (id: string) => `/shops/${id}/temporaries/withdraw`,
  shopTemporariesUpdate: (id: string) => `/shops/${id}/temporaries`,
  shopApprovalRequests: '/shops/temporaries',
  salesPerformanceHistory: '/sale-figures',
  salesPerformanceHistoryDetail: '/sale-figures/detail',
  salesPerformanceFiscalMonth: '/fiscal-months/detail',
  salesPerformanceSaleFiguresDetail: '/sale-figures/detail',
  salesPerformanceSaleFigureShopDetail: (id: string) =>
    `/sale-figure-shops/${id}`,
  salesPerformanceSaleFigureShopUpdate: (id: string) =>
    `/sale-figure-shops/${id}`,
  salesPerformanceSaleFigureShopDraft: (id: string) =>
    `/sale-figure-shops/${id}/draft`,
  salesPerformanceSubmit: (id: string) => `/sale-figures/${id}/submit`,
  salesPerformanceWithdraw: (id: string) => `/sale-figures/${id}/withdraw`,
  salesPerformanceSendBack: (id: string) => `sale-figures/${id}/send-back`,
  salesPerformanceSkipRegistration: (id: string) =>
    `/sale-figures/${id}/skip-registration`,
  salesPerformanceFiscalMonthClosingCompleted: (id: string) =>
    `/fiscal-months/${id}/monthly-closing-completed`,
  salesPerformanceFiscalMonthApproveAll: (id: string) =>
    `/fiscal-months/${id}/registration-completed`,
  salesPerformanceFiscalMonthOutputCSV: (id: string) =>
    `/fiscal-months/${id}/csv-output`,
  salesPerformanceFiscalMonthOutputCSVAt: (id: string) =>
    `/fiscal-months/${id}/csv-output-at`,
  amountAdjustmentDetail: (id: string) => `/billing-adjustments/${id}`,
  amountAdjustmentUpdate: (id: string) =>
    `/sale-figures/${id}/billing-adjustments`,
  banners: '/banners',
  bannersDetail: (id: string) => `/banners/${id}`,
  drinks: '/drinks',
  templates: '/templates',
  drinksDetail: (id: string) => `/drinks/${id}`,
  shopDrinks: (id: string) => `/shops/${id}/drinks`,
  snapLabels: '/snap-drinks',
  snapLabelDetail: (id: string) => `/shops/${id}/snap-drink`,
  snapDrinkTemplates: '/snap-drink-templates',
  shopLabelSets: (id: string) => `/shops/${id}/label-sets`,
  fullIpLabels: '/full-ips',
  fullIpLabelsDraft: '/full-ips/draft',
  fullIpLabelsDetail: (id: string) => `/full-ips/${id}`,
  fullIpLabelsUpdateDraft: (id: string) => `/full-ips/${id}/draft`,
  acodeUpdateDownload: '/billing-information/download',
  acodeUpdateHistory: '/billing-information/history',
  acodeUpdateUpload: '/billing-information/upload',
} as const;
